import { render, staticRenderFns } from "./SolanStudentViewRubricsT.vue?vue&type=template&id=20e1e3a3&scoped=true&"
import script from "./SolanStudentViewRubricsT.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewRubricsT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewRubricsT.vue?vue&type=style&index=0&id=20e1e3a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1e3a3",
  null
  
)

export default component.exports